/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dr_Proof_TitleInputs */

const en_dr_proof_title = /** @type {(inputs: Dr_Proof_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Every feature carries its origin`)
};

const id_dr_proof_title = /** @type {(inputs: Dr_Proof_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiap fitur membawa asal-usulnya`)
};

/**
* | output |
* | --- |
* | "Every feature carries its origin" |
*
* @param {Dr_Proof_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const dr_proof_title = /** @type {((inputs?: Dr_Proof_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dr_Proof_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_dr_proof_title(inputs)
	return en_dr_proof_title(inputs)
});